 import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
// import { ReplaceChar } from '../shared/customizefilters.pipe';
import { PlatformRoutingModule } from './platform-routing.module';
import { DesignerModule } from './designer/designer.module';
import { CustomerModule } from './customer/customer.module';
import { OrganisationModule } from './organisation/organisation.module'
import { ProjectModule } from './project/project.module';
import { ProfileModule } from './profile/profile.module';
import { LeadModule } from './lead/lead.module';
import { QuotationModule } from './quotation/quotation.module';
import { SchedulerModule } from './scheduler/scheduler.module';
import { TestimonialModule } from './testimonial/testimonial.module';
import { ModularproductscatalogueModule } from './modularproductscatalogue/modularproductscatalogue.module';
import { PresentationModule } from './presentation/presentation.module';
import { CalenderModule } from './calender/calender.module';
import { FinanceModule } from './finance/finance.module';
import { CategoryModule} from './category/category/category.module';
import { SitesupervisorModule } from './sitesupervisor/sitesupervisor.module';
import { ReferralModule } from './referral/referral.module';
import { OrderManagerModule } from './order-manager/order-manager.module';

@NgModule({
  imports: [
    CommonModule,
    PlatformRoutingModule,
    DesignerModule,
    CustomerModule,
    OrganisationModule,
    ProjectModule,
    ProfileModule,
    LeadModule,
    QuotationModule,
    SchedulerModule,
    TestimonialModule,
    ModularproductscatalogueModule,
    PresentationModule,
    CalenderModule,
    FinanceModule,
    CategoryModule,
    SitesupervisorModule,
    ReferralModule,
    OrderManagerModule,
  ],
  declarations: [],
})
export class PlatformModule { }



// WEBPACK FOOTER //
// /Users/shobhit/Documents/codes/arrivae-frontend/src/app/platform/platform.module.ts